import React from 'react'
import 'jquery.easing'
import { useLocation, Link } from "react-router-dom";
import $ from "jquery";
import UrlParamChecker from './UrlChecker';
const FooterUI = (props) => {
  const location = useLocation();


  return (<div>
    <footer id="footer" style={UrlParamChecker() ? { display: "none" } : {}} className={props.footerClass ? props.footerClass : ""}>
      <div className="container">
        <div className="copyright">
          <div className="row">
            <div className="col-md-6">
              &copy; Copyright{" "}
              <strong>
                <span>RBI Retail Direct. </span>
              </strong>
              All Rights Reserved with{" "}
              <a
                href="https://www.rbi.org.in/"
                title="Link will open in new Tab"
                target="_blank"
              >
                Reserve Bank of India{" "}
                <i
                  className="ri-external-link-line"
                  style={{ verticalAlign: "-3px" }}
                ></i>
              </a>
            </div>
            <div className="col-md-6 footer-links">
              <Link to='/PrivacyPolicy'>Privacy Policy</Link>
              <Link to="/Disclaimer">Disclaimer</Link>
              <Link to="/Contact">Contact</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div className="amg-floating-contacts">

      <div style={UrlParamChecker() ? { display: "none", } : {}} className="amg-floating-contact-wrap">
        <div className="amg-floating-icon" title="Contact Us">
          <i className="ri-customer-service-2-line"></i>
        </div>
        <div className="amg-floating-link">
          {/* <!-- <h4>Contact Us</h4> --> */}
          <div className="row">
            {/* <!-- <div className="col-md-12">
                        <div>
                            <h6>RBI Contact Details</h6>
                            <p><i className="ri-phone-line"></i> <a href="tel:+022-22603456">022-22603456</a></p>
                            <p><i className="ri-phone-line"></i> <a href="tel:+022-22603457">022-22603457</a></p>
                            <p><i className="ri-mail-line"></i> <a href="mailto:retaildirect@rbi.org.in">retaildirect@rbi.org.in</a></p>
                        </div>
                    </div> --> */}

            <div className="col-md-12" >
              <div>
                <h6>RBI Retail Direct Support</h6>
                <p><i className="ri-phone-line"></i> <i className="ri-arrow-right-up-line" style={{ marginLeft: '-4px' }}></i><a href="tel:1800 267 7955" title="Out-Bound Number">1800 267 7955</a></p>
                <p><i className="ri-phone-line"></i> <i className="ri-arrow-left-down-line" style={{ marginLeft: '-4px' }}></i><a href="tel:+91-22-61546335" title="In-Bound Number">+91-22-61546335</a></p>
                <p><i className="ri-mail-line"></i> <a href="mailto:support@rbiretaildirect.org.in">support@rbiretaildirect.org.in</a></p>
                <p><i className="ri-time-line"></i> <a style={{ color: '#000' }}>10am - 6pm (Mon - Sat)</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}; export default FooterUI